<template>
  <v-container fluid>
    <!--    <h1 class="headline mb-1">Planes adquiridos</h1>-->
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialogRepo = true">Crear Repositorio</v-btn>
        </v-card-title>    
        <v-data-table 
          :headers="headersRepositorios"
          :items="array_repositorios"
          :items-per-page="10"
          :search="search"
          class="elevation-1">
          <template v-slot:item.action="{ item }">
            <v-btn fab x-small @click="editRepo(item)" class="mr-2">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
        
          <template v-slot:item.estado="{ item }">
              <v-chip v-if="item.estado == 'ACTIVO'" x-small color="success" text-color="white"> Activo </v-chip>
              <v-chip v-else x-small color="red" text-color="white"> Inactivo </v-chip>
          </template>
        </v-data-table>

        <v-dialog v-model="dialogRepo" persistent max-width="600px">
          <v-card>
            <v-card-title class="headline">
              <span v-if="es_nueva">Agregar Repositorio</span>  
              <span v-if="!es_nueva">Actualizar Repositorio</span>  
            </v-card-title>
            <v-card-text>
              <v-form ref="formRepo" v-model="validRepo" lazy-validation>
                <v-text-field 
                  v-model="repo.nombre"
                  label="Nombre"
                  :rules="[rules.required]" >
                  </v-text-field>
                  <v-select
                    v-model="repo.tipo"
                    :items="tipos"
                    :item-text="tipos.text"
                    :item-value="tipos.value"
                    :rules="[rules.required]"
                    label="Tipo"
                  ></v-select>
                  <v-select
                    v-model="repo.propio"
                    :items="propio"
                    :item-text="propio.text"
                    :item-value="propio.value"
                    :rules="[rules.required]"
                    label="¿El repositorio es proporcionado por el cliente?"
                  ></v-select>


                  <v-text-field 
                  v-model="repo.credenciales"
                  label="Credenciales"
                  :rules="[rules.required]" >
                  </v-text-field>
                  <v-text-field 
                  v-model="repo.raiz"
                  label="Raiz"
                  :rules="[rules.required]" >
                  </v-text-field>
                  <v-radio-group v-if="!es_nueva" v-model="repo.estado" >
                    <v-radio label="Activo" value="ACTIVO"></v-radio>
                    <v-radio label="Inactivo" value="INACTIVO"></v-radio>
                  </v-radio-group>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="resetRepo"> Cerrar </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!validRepo" :loading="loading" v-if="es_nueva" color="primary" class="mr-4" @click="saveRepo"> 
                Grabar 
              </v-btn>
              <v-btn :disabled="!validRepo" :loading="loading" v-if="!es_nueva" color="primary" class="mr-4" @click="updateRepo"> 
                Actualizar 
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

  </v-container>
</template>

<script>
import axios from "axios";
  
export default {
  components: { 

  },
  data: function() {
    return {
      es_nueva: true,
      search: null,
      array_repositorios: [],
      current_repo: null,
      dialogRepo: false,
      validRepo: true,
      selected_id: null,
      loading:false,
      repo: {
        nombre: null,
        tipo: null,
        propio:null,
        credenciales: null,
        raiz: null
      },
      tipos: [
        { text: "Local", value: "local"},
        { text: "S3", value: "s3"},
      ],
      propio: [
        { text: "Si", value: "SI"},
        { text: "No", value: "NO"},
      ],
      headersRepositorios: [
        //{ text: 'Id', value: 'id', sortable: false,  },
        { text: 'Nombre', value: 'nombre', sortable: false },
        { text: 'Tipo', value: 'tipo', sortable: false },
        { text: 'Propio', value: 'propio', sortable: false },
        { text: 'Credenciales', value: 'credenciales', sortable: false },
        { text: 'Raiz', value: 'raiz', sortable: false },
        { text: 'Estado', value: 'estado', sortable: false },
        { text: 'Acciones', value: 'action', sortable: false }
      ],
      rules: {
        required: value => !!value || 'Campo Requerido.',
      },
    };
  },
  computed: {

  },
  mounted() {
    console.log("Repositorios.vue");
    this.getRepositorios();
  },
  methods: {
    getRepositorios(){
      let usuarios = axios.get('Repositorio/listar?AgrupadorId='+ this.$route.params.id, { 'headers': this.$store.state.user.headers });
      return usuarios.then((callback) =>
      {
        this.array_repositorios = callback.data;
      }).catch((error) => {
        console.log("ERROR EN EL CALLBACK" + error);
      });
    },
    saveRepo() {
      let _this0 = this;
      if (this.$refs.formRepo.validate()) {
        _this0.loading = true;
        let postRepo = axios.post('Repositorio/Crear', 
          {
            "nombre": _this0.repo.nombre,
            "tipo": _this0.repo.tipo,
            "propio": _this0.repo.propio,
            "credenciales": _this0.repo.credenciales,
            "raiz": _this0.repo.raiz,
            "estado": "ACTIVO",
            "agrupadorId": _this0.$route.params.id
          },
          { 'headers': _this0.$store.state.user.headers }
        )
        return postRepo.then((callback) => {
          if(callback.status ==201){
            _this0.resetRepo();
            _this0.getRepositorios();
            _this0.dialogRepo = false;
            _this0.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Repositorio agregado' });
          }
        }).catch((error1) => {
          this.dialogRepo = true;
          this.loading = false;
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 2' });
          console.log(error1);
        });
      }
    },
    resetRepo() {
      this.es_nueva = true;
      this.dialogRepo = false;
      this.loading = false;
      this.$refs.formRepo.reset();
    },
    editRepo(data) {
      this.current_repo = data;
      this.dialogRepo = true;
      this.es_nueva = false;
      this.selected_id = data.id;
      this.repo = {
        'raiz': data.raiz,
        'tipo': data.tipo,
        'propio': data.propio,
        'nombre': data.nombre,
        'credenciales': data.credenciales,
        'estado': data.estado,
      }
    },
    updateRepo() {
      console.log("updateRepo");
      let _this2 = this;
      if (this.$refs.formRepo.validate()) {
        this.loading = true;
        this.dialogRepo = false;
        let getuser = axios.put('Repositorio/actualizar', 
          { 'id': this.selected_id, 
            'nombre': this.repo.nombre,
            'tipo': this.repo.tipo,
            'propio': this.repo.propio,
            'raiz': this.repo.raiz,
            'credenciales': this.repo.credenciales,
            "agrupadorId": this.$route.params.id, 
            'estado': this.repo.estado, 
          },
          { 'headers': this.$store.state.user.headers }
        )
        return getuser.then((callback) => {
          if(callback.status == 200) {
            this.current_repo.nombre = _this2.repo.nombre;
            this.current_repo.tipo = _this2.repo.tipo;
            this.current_repo.propio = _this2.repo.propio;
            this.current_repo.raiz = _this2.repo.raiz;
            this.current_repo.credenciales = _this2.repo.credenciales;
            this.current_repo.estado = _this2.repo.estado;
            this.resetRepo();
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
          } else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operación' });
            this.loading = false;
          }
        }).catch((error) => {
          console.log(error);
          this.es_nueva = false;
          this.dialogRepo = true;
          this.loading = false;
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operación' });
        });
      }
    },    

  },
};
</script>